import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { MediaObserver } from "@angular/flex-layout";

import { ProductService } from "src/app/services/api/product/product.service";

import { FulleStockService } from "src/app/services/api/fulle/fulle-stock/fulle-stock.service";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";

@Component({
  selector: "app-rub-prod-list",
  templateUrl: "./rub-prod-list.component.html",
  styleUrls: ["./rub-prod-list.component.css"],
})
export class RubProdListComponent implements OnInit {
  @Output() openProdDialEvent = new EventEmitter<any>();
  @Output() deconnectionEvent = new EventEmitter();
  @Output() moreProductsEvent = new EventEmitter();

  @Input() rubrics$: any;
  @Input() products$: any;
  @Input() newRubricsDisplay$: any;
  @Input() merchantClient$: any;
  @Input() user_: any;
  @Input() scrollingElementProd: any;
  @Input() loaderpop: any;
  @Input() pointOfsale: any;
  @Input() more_products_button: any;
  @Input() count: any;
  @Input() limit_from: any;

  onStartDisplay: number = 0;
  onEndDisplay: number = 0;
  minDisplayProduct: number = 50;


  stockObservable: any;


  callProd = 0;
  numberproductsDisplay = 0;

  constructor(
    public media: MediaObserver,
    private stockApi: FulleStockService,
    public myDials: DialogsService,
    public ProductService: ProductService
  ) {
  }

  ngOnInit() {
    //change le stock du produit changé dans le panier
    this.stockObservable = this.stockApi.getCurrStock().subscribe(value => {
      if (value)
        this.setCountStock(value);
    });
  }

  ngOnChanges(changes: SimpleChanges | any): void {
    //affichage des produits avec limit ou  par categorie unique  ou toutes les categories
    if (this.newRubricsDisplay$ && changes && changes.newRubricsDisplay$)
      this.rubrics$ = this.newRubricsDisplay$;
    if (changes && changes.limit_from)
      this.callProd = 0
  }

  ngOnDestroy(): void {
    if (this.stockObservable)
      this.stockObservable.unsubscribe();
  }

  openProdDial(prod: any, data?: any): void {
    this.openProdDialEvent.emit(prod);
  }

  getprodStock(id: any) {
    return this.stockApi.getProdStock(id).count;
  }

  // isDisplayRectangle() {
  //   return (this.pointOfsale && this.pointOfsale.webshop_display_mode == 1) && !this.media.isActive('xs')
  // }

  // isDisplaySquare() {
  //   return (this.pointOfsale && this.pointOfsale.webshop_display_mode == 0) || this.media.isActive('xs')
  // }

  private get displayMode(): number {
    return this.pointOfsale?.webshop_display_mode ?? 0; // 0 par défaut
  }

  isDisplayRectangle() {
    return (this.displayMode === 1) && !this.media.isActive('xs')
  }

  isDisplaySquare() {
    return (this.displayMode === 0) || this.media.isActive('xs')
  }


  Moreproducts(rub?: any) {
    let newrub = {
      id: this.rubrics$.length > 1 ? "all" : rub.id
    }
    this.moreProductsEvent.emit(newrub);
  }

  setCountStock(change: any) {
    if (this.rubrics$ && this.rubrics$.length > 0) {
      this.rubrics$.forEach((element: any) => {
        let check = element.products.find((value: any) => value.id == change.id);
        if (check)
          check.stock.count = change.count;
      });
    }
  }
}
